import EditSvg from '../assets/img/svg/edit'
import CopySvg from '../assets/img/svg/copy'
import BellSvg from '../assets/img/svg/bell'

const GridWebhooks = ({ dataList, setEditWebhook, toast }) => {
  return (
    <>
      <div className="grid-head-webhooks">
        <span>ID</span>
        <span>Pipeline</span>
        <span>Webhook</span>
      </div>
      <div className="grid-flex">
        {dataList &&
          dataList.map((e) => {
            const webhookLink = `https://back.traderiq.net/api/v1/webhooks/event/${e.key}`
            return (
              <div
                className={`grid-table-webhooks${
                  e.soft_delete ? '-delete' : ''
                }`}
                key={e.id}
              >
                <span className="grid-id">#{e.id}</span>
                <span className="grid-item">{e.name}</span>
                <span className="grid-item">
                  <CopySvg
                    className="grid-close"
                    onClick={() => {
                      if (!e.soft_delete) {
                        navigator.clipboard.writeText(webhookLink)
                        toast(
                          <span className="notify_-copy-link">
                            <BellSvg />
                            <span>Copied</span>
                          </span>
                        )
                      }
                    }}
                  />
                  {webhookLink}
                </span>
                <div className="grid-menu">
                  <EditSvg
                    onClick={() => {
                      if (!e.soft_delete) {
                        setEditWebhook(e)
                      }
                    }}
                  />
                </div>
              </div>
            )
          })}
      </div>
    </>
  )
}

export default GridWebhooks
